import { render, staticRenderFns } from "./CreateProjectDrawer.vue?vue&type=template&id=bd1aa7fc&scoped=true&"
import script from "./CreateProjectDrawer.vue?vue&type=script&lang=js&"
export * from "./CreateProjectDrawer.vue?vue&type=script&lang=js&"
import style0 from "./CreateProjectDrawer.vue?vue&type=style&index=0&id=bd1aa7fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1aa7fc",
  null
  
)

export default component.exports